import React from 'react';

export interface ProgressDashboardProps {
  selected?: boolean;
  white?: boolean;
  onClick?: () => void;
  className?: string;
}

export const ProgressDashboardMiniature: React.FC<ProgressDashboardProps> = ({
  children,
  onClick,
  selected,
  className,
  white,
}) => {
  return (
    <div
      onClick={onClick}
      className={`
        w-full
        h-full
        transition duration-50
        rounded-xl
        ${className}
        ${onClick && 'cursor-pointer'}
        ${selected && 'bg-white'}
        ${white && 'bg-white'}
        ${!selected && !white && 'bg-gray-100/75'}
        ${!selected && 'hover:shadow-md'}
        p-4
        flex flex-col
        group shadow-sm
    `}
    >
      {children}
    </div>
  );
};

export default ProgressDashboardMiniature;
